<div class="col-md-12 " >
  
    <div class="row pt-3 col-md-12">
      <div class="col-md-12 d-flex justify-content-end">
        <div class="col-md-12 row">
          <mat-form-field class="col-md-4" appearance="outline">
            <mat-label>Supplier</mat-label>
            <mat-select matNativeControl name="supplier" [(ngModel)]="searchRequest.supplierId" >
              <mat-option *ngFor="let item of supplierList" [value]="item.code">{{item.name}}</mat-option>

              </mat-select>             
    
            </mat-form-field>

            <mat-form-field class="col-md-4" appearance="outline">
              <mat-label>Source</mat-label>
              <mat-select matNativeControl name="source" [(ngModel)]="searchRequest.sourceId" >
                <mat-option *ngFor="let item of sourceCodeList" [value]="item.code">{{item.title}}</mat-option>
    
                </mat-select>             
        
              </mat-form-field>

      <mat-form-field class="col-md-4" appearance="outline">
        <mat-label>Carrier</mat-label>

        <mat-select matNativeControl name="carrier"  [(ngModel)]="searchRequest.carrierCode">
          <mat-option value="">Any</mat-option>
          <mat-option *ngFor="let item of carrierList" [value]="item?.airlineDesignatorCode">{{ item.carrierName }}</mat-option>

          </mat-select>             
    
        </mat-form-field>
       
        
          </div>
          </div>

    <!-- <mat-form-field class=" col-md-3 mt-1 form-group " >
      <input matInput type="text"  [(ngModel)]="searchText"   placeholder="Search..." autocomplete="off" (input)="searchSource()"  >
    
    </mat-form-field> -->
    <div class="col-md-12 d-flex justify-content-center">
      <div class="col-md-4 row">
     
      </div>
        <div class="col-md-4"></div>
      <div class="row col-md-4 ">
      <span class="col-md-7">
        <button mat-flat-button  style="min-width: 100%; height: 55px; color: white; background-color: #007bff; margin-left: 8px;font-weight: bold;" (click)="RBDList()"  [disabled]="disabled">SEARCH </button>
      </span>
      <span class="col-md-5"> 
        <button   mat-flat-button  style="width: auto; height: 55px; color: white; background-color: #1e8f5a;; margin-right: 8px;font-weight: bold;" (click)="OnClickPopup()" >ADD&nbsp;RBD </button>

</span>
</div>
    </div>
    <!-- <mat-paginator  class="col-md-8 mt-2 " style="background-color: transparent;" color="primary"
    [pageSize]="10"
    [pageSizeOptions]="[5, 10, 25, 100]"
    [length]="totalElements"
    (page)="nextPage($event)"
    aria-label="Select page">
    </mat-paginator> -->
    
    </div>
    
    <table mat-table
    [dataSource]="rbdList" multiTemplateDataRows style="background-color: transparent;">
   
    <!-- <ng-container matColumnDef="code">
     <th mat-header-cell *matHeaderCellDef> Code </th>
     <td mat-cell *matCellDef="let element;"> {{element.code}} </td>
    </ng-container> -->
     <ng-container matColumnDef="supplier">
       <th mat-header-cell *matHeaderCellDef>Supplier</th>
       <td mat-cell *matCellDef="let element"  > {{filterSupplier(element.supplierId)}} </td>
     </ng-container>
     <!-- style="padding: 4px; cursor: pointer; color: rgb(24,118,209);" -->
     <ng-container matColumnDef="source">
      <th mat-header-cell *matHeaderCellDef> Source </th>
      <td mat-cell *matCellDef="let element"  (click)="rowClick(element)"> {{filterSource(element?.sourceId)}} </td>
     </ng-container>
    <ng-container matColumnDef="iata">
     <th mat-header-cell *matHeaderCellDef> Iata Code </th>
     <td mat-cell *matCellDef="let element" > 
      {{filterCarrier(element?.carrierCode)}}
    </td>
    </ng-container>
    <ng-container matColumnDef="paymentChannel">
      <th mat-header-cell *matHeaderCellDef>Payment Channel</th>
      <td mat-cell *matCellDef="let element"> {{element?.paymentChannel}} </td>
     </ng-container>
     <ng-container matColumnDef="action">
      <th mat-header-cell *matHeaderCellDef>Action</th>
      <td mat-cell *matCellDef="let element"  style="padding: 4px; cursor: pointer; color: rgb(24,118,209);text-align: start;" (click)="rowClick(element)" > <mat-icon>edit</mat-icon> </td>
     </ng-container>
     <!-- <ng-container matColumnDef="rbdDom">
      <th mat-header-cell *matHeaderCellDef>RBD Dom </th>
      <td mat-cell *matCellDef="let element"> 
        <span *ngIf="element?.domestic==='true'">True</span>
        <span *ngIf="element?.domestic==='false'">False</span>

         </td>
     </ng-container>
     <ng-container matColumnDef="rbdInt">
        <th mat-header-cell *matHeaderCellDef>RBD Intl </th>
        <td mat-cell *matCellDef="let element"> 
          {{element?.classTypes }} 
          <span *ngIf="element?.international==='true'">True</span>
          <span *ngIf="element?.international==='false'">False</span>
        </td>
       </ng-container>
       <ng-container matColumnDef="regions">
        <th mat-header-cell *matHeaderCellDef>Regions</th>
        <td mat-cell *matCellDef="let element"> {{element?.regions}} </td>
       </ng-container>
       <ng-container matColumnDef="applyOn">
        <th mat-header-cell *matHeaderCellDef>Apply On </th>
        <td mat-cell *matCellDef="let element"> {{element?.fareBasisRegex}} </td>
       </ng-container>
       <ng-container matColumnDef="chargeOb">
        <th mat-header-cell *matHeaderCellDef>Charge OB </th>
        <td mat-cell *matCellDef="let element"> {{element?.flightRegex}} </td>
       </ng-container> -->
      
    <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
    <ng-container matColumnDef="expandedDetail">
    <td mat-cell *matCellDef="let element" [attr.colspan]="columnsDisplay.length">
    <!-- <div class="example-element-detail row"
     [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
    
    </div> -->
    </td>
    </ng-container>
    
    <tr mat-header-row *matHeaderRowDef="columnsDisplay"></tr>
    <tr mat-row *matRowDef="let element; columns: columnsDisplay;"
    class="example-element-row">
    </tr>
    <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
    <tr class="mat-row" *matNoDataRow>
    <td  class="mat-cell" colspan="4">There is no data in this table</td>
    </tr>
    </table>
    
    
    </div>

    <div class="modal " id="myMod"  [style.display]="popup ? 'block' : 'none'" >
      <div class="modal-dialog" >
          <div class="modal-content" style="width:110%; margin: 10% 40% auto;" >
              <div class="modal-header title" *ngIf="rbdAction==='new'">
                Add RBD
                  <button type="button" class="close" data-dismiss="modal" (click)="closePopup()">&times;</button>
              </div>
              <div class="modal-header title" *ngIf="rbdAction==='Update'">
                Edit RBD
                  <button type="button" class="close" data-dismiss="modal" (click)="closePopup()">&times;</button>
              </div>
            <div class="modal-body">
              <mat-form-field class="col-md-12" appearance="outline">
                <mat-label>Supplier</mat-label>
                <mat-select matNativeControl name="supplier" [(ngModel)]="rbdRequest.supplierId" >
                  <mat-option *ngFor="let item of supplierList" [disabled]="rbdAction==='Update'" [value]="item.code">{{item.name}}</mat-option>
    
                  </mat-select>             
        
                </mat-form-field>
    
                <mat-form-field class="col-md-12" appearance="outline">
                  <mat-label>Source</mat-label>
                  <mat-select matNativeControl name="source" [(ngModel)]="rbdRequest.sourceId" >
                    <mat-option *ngFor="let item of sourceCodeList" [disabled]="rbdAction==='Update'" [value]="item.code">{{item.title}}</mat-option>
        
                    </mat-select>             
            
                  </mat-form-field>
    
          <mat-form-field *ngIf="rbdAction!='Update'" class="col-md-12" appearance="outline">
            <mat-label>Carrier</mat-label>
          
              <input  type="text"
              placeholder="Search..."
              matInput
              [formControl]="myControl"
              style="position:relative;border: none ;border-bottom: 2px solid;width: 100%;outline: none;"
              [matAutocomplete]="auto">
       <mat-autocomplete  autoActiveFirstOption #auto="matAutocomplete" (optionSelected)="changeCarrier()">
       <mat-option *ngFor="let option of filteredOptions | async;" [value]="option.carrierName+','+option.airlineDesignatorCode">{{option?.carrierName+','+option?.airlineDesignatorCode}}</mat-option>
         
       </mat-autocomplete>
            </mat-form-field>
            <mat-form-field *ngIf="rbdAction==='Update'" class="col-md-12" appearance="outline">
              <mat-label>Carrier</mat-label>
              <mat-select  matNativeControl name="carrier"  [(ngModel)]="rbdRequest.carrierCode" (selectionChange)="onCarrierChange()">
                <mat-option  [disabled]="rbdAction==='Update'" value="" >Any</mat-option>
                <mat-option *ngFor="let item of carrierList" [disabled]="rbdAction==='Update'" [value]="item?.airlineDesignatorCode">{{ item.carrierName }}</mat-option>
      
                </mat-select>             
          
              
              </mat-form-field>
            <mat-form-field *ngIf="rbdRequest.carrierCode" class="col-md-12" appearance="outline">
              <mat-label>Booking Class ( Separated By : )</mat-label>
              <input matInput [(ngModel)]="rbdRequest.carrierBookingClass">
                    
          
              </mat-form-field>

            

            <mat-radio-group 
            [(ngModel)]="PaymentType"
            class="custom-radio-group" (change)="onSelectionChange()"
          >
            <mat-radio-button value="A" color="primary" class="custom-radio-button">Selection Rule</mat-radio-button>
            <mat-radio-button value="M" color="primary" class="custom-radio-button">Manual Selection</mat-radio-button>
          </mat-radio-group>
          <mat-form-field *ngIf="PaymentType==='A'" class="col-md-12" appearance="outline">
            <mat-label>Tags</mat-label>
            <mat-select multiple matNativeControl name="tags"  [(ngModel)]="rbdRequest.paymentChannelTags">
              <mat-option *ngFor="let item of tagDataList"  [value]="item?.tagId">{{ item.tagName }}</mat-option>
    
              </mat-select>             
        
            </mat-form-field>
            <mat-form-field *ngIf="PaymentType==='M'" class="col-md-12" appearance="outline">
              <mat-label>Payment Channels</mat-label>
              <mat-select matNativeControl name="source" [(ngModel)]="rbdRequest.paymentChannel" >
                <mat-option   *ngFor="let item of paymentChannelList?.paymentChannels" [value]="item">{{item}}</mat-option>
                

                </mat-select>             
        
              </mat-form-field>
              <mat-form-field *ngIf="PaymentType==='M'&&rbdRequest.paymentChannel==='CARD'" class="col-md-12" appearance="outline">
                <mat-label>CARD REFERENCE</mat-label>
         <mat-select multiple [(ngModel)]="rbdRequest.paymentChannelRef">
         <mat-option *ngFor="let item of creditDetail(CreditData,rbdRequest.sourceId)" [value]="item.maskedCardNumber">{{item?.maskedCardNumber }}({{item?.cardType }})</mat-option>
         </mat-select>

                <!-- <input matNativeControl type="text">           -->
          
                </mat-form-field>
              
             </div>

                  
                  <div class="modal-footer">
                    <button  *ngIf="rbdAction==='Update'"  class="btn btn-outline-success c-width-100px shadow" (click)="updateRBD()" [disabled]="disabled || disable()">UPDATE&nbsp;RBD</button>

                    <button  *ngIf="rbdAction==='new'"  class="btn btn-outline-success c-width-100px shadow" (click)="AddRBD()" [disabled]="disabled || disable()">ADD&nbsp;RBD</button>
                    <button type="button" class="btn btn-outline-primary c-width-100px shadow" data-dismiss="modal" (click)="closePopup()">Close</button>
                   
               
                  </div>
                  
                </div>
                </div>
        </div>
  